module.exports = "/_next/static/images/Hero@2x-0e2edae2babc1c255b6a207f86564c49.webp";